import React from 'react';
import './globalLoading.css';

type GlobalLoadingProps = {
    text: string;
};

const GlobalLoading = ({ text }: GlobalLoadingProps) => {
    return <React.Fragment>
        <div className="loadding_bg print_none"></div>
        <div className="loadding print_none" role="status" aria-live="polite" aria-label={text}>
            <div className="circle-wrapper" aria-hidden="true">
                <div className="circle_1 circle"></div>
                <div className="circle_2 circle"></div>
                <div className="circle_3 circle"></div>
                <div className="circle_4 circle"></div>
                <div className="circle_5 circle"></div>
                <div className="circle_6 circle"></div>
                <div className="circle_7 circle"></div>
                <div className="circle_8 circle"></div>
            </div>
            <p className="loadding_text">{text}</p>
        </div>
    </React.Fragment>;
};

export default GlobalLoading;